import copyNotification from '../common/utils/copy-notification';

const selector = '[data-color-swatch]';
const tooltipContent = 'Click to Copy Hex Code';

const initializeSwatch = (swatch) => {
    const $swatch = $(swatch);

    const tooltip = copyNotification.initialize(
        swatch,
        {
            content: tooltipContent,
            trigger: 'mouseenter focus',
            autoHideDelay: null,
            onHidden: (instance) => {
                instance.setContent(tooltipContent);
            },
        }
    );

    $swatch.on('click', async (event) => {
        event.preventDefault();

        const hexCode = $swatch.attr('data-color-swatch') ?? '';

        if (hexCode.length === 0) {
            return;
        }

        await navigator.clipboard.writeText(hexCode);

        tooltip.setContent('Copied!');
        tooltip.show();

        setTimeout(() => {
            tooltip.hide();
        }, 2000);
    });
};

const initialize = () => {
    $(selector).each((_, swatch) => {
        initializeSwatch(swatch);
    });
};

export default {
    initialize,
};
